// extracted by mini-css-extract-plugin
export var circle = "_el-1";
export var exitConfirmationModal = "_el-5";
export var iframe = "_el-0";
export var offline = "_el-3";
export var online = "_el-2";
export var workstationSelectError = "_el-4";